import * as React from 'react';

const HoneyPot = () => {
    return (
        // @ts-ignore
        <a href="/v1/lot/" style={{ ariaHidden: 'true', display: 'none' }}>
            lots of lots
        </a>
    );
};

export default HoneyPot;
